export var Breakpoint = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint["LARGE"] = "large";
    Breakpoint["SMALL"] = "small";
    return Breakpoint;
}({});
export const DEFAULT_BREAKPOINT = "large";

//# sourceMappingURL=breakpoints.js.map